/* tslint:disable */
/* eslint-disable */
/**
 * AMONDZ-ADMIN-BACKEND-V2
 * AMONDZ-ADMIN-BACKEND-V2 API 문서입니다.
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { EventsFindResponseBodyEventAttachmentsDto } from './events-find-response-body-event-attachments-dto';
// May contain unused imports in some cases
// @ts-ignore
import { EventsFindResponseBodyTagsDto } from './events-find-response-body-tags-dto';

/**
 *
 * @export
 * @interface EventsFindResponseBodyEventsDto
 */
export interface EventsFindResponseBodyEventsDto {
  /**
   * 이벤트 식별 id
   * @type {number}
   * @memberof EventsFindResponseBodyEventsDto
   */
  id: number;
  /**
   * 이벤트 목록에 노출되는 이벤트 타이틀
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  mainTitle: string;
  /**
   * 이벤트 내용 (본문)
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  contents: string;
  /**
   * 이벤트에 대한 메모
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  memo: string;
  /**
   * 이벤트 생성 일자
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  createDate: string;
  /**
   * 이벤트 수정 일자
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  updateDate: string;
  /**
   * 기획전 상태 (active: 활성, inactive: 비활성, unlimited: 무기한)
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  status: EventsFindResponseBodyEventsDtoStatusEnum;
  /**
   * 기획전 시작 일자
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  startDate: string | null;
  /**
   * 기획전 종료 일자
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  endDate: string | null;
  /**
   * 기획전 링크 url
   * @type {string}
   * @memberof EventsFindResponseBodyEventsDto
   */
  url: string;
  /**
   *
   * @type {Array<EventsFindResponseBodyTagsDto>}
   * @memberof EventsFindResponseBodyEventsDto
   */
  tags: Array<EventsFindResponseBodyTagsDto>;
  /**
   *
   * @type {Array<EventsFindResponseBodyEventAttachmentsDto>}
   * @memberof EventsFindResponseBodyEventsDto
   */
  eventAttachments: Array<EventsFindResponseBodyEventAttachmentsDto>;
}

export const EventsFindResponseBodyEventsDtoStatusEnum = {
  Inactive: 'inactive',
  Active: 'active',
  Unlimited: 'unlimited',
} as const;

export type EventsFindResponseBodyEventsDtoStatusEnum =
  (typeof EventsFindResponseBodyEventsDtoStatusEnum)[keyof typeof EventsFindResponseBodyEventsDtoStatusEnum];
